var getVouchers = {
  vouchers: {
    query: `query getVoucher(
      $userExtId: String!
      $voucherCode: String!
      $activeOnly: Boolean!
      $voucherCodeMayBeBookingReference: Boolean!
    ) {
      getVoucher(userExtId: $userExtId, voucherCode: $voucherCode, activeOnly: $activeOnly, voucherCodeMayBeBookingReference: $voucherCodeMayBeBookingReference) {
        ...voucher
      }
    }
    fragment voucher on Voucher {
      id
      label
      bookingRef
      totalValue
      remainingValue
      currency
      nonFlex
      expires
      created
      productType
      agentCode
      refundValue
      redemptions {
        bookingRef
      }
      refunds {
        value
      }
      cancellationFeeRedeemable
      redemptionConditions {
        agentGroupCode
        productAuthority
      }
    }`,
    variables: {
      userExtId: '',
      voucherCode: '',
      activeOnly: true,
      voucherCodeMayBeBookingReference: true
    }
  },
  voucherRefund: {
    query: `mutation($voucherCode: String!, $userExtId: String!) {
      requestVoucherRefund(voucherCode: $voucherCode, userExtId: $userExtId)
    }`,
    variables: {
      userExtId: '',
      voucherCode: ''
    }
  }
}

module.exports = getVouchers



// WEBPACK FOOTER //
// ./shared/config/getVoucher.js